var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicSection = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@wheelroom/core");
const topic_section_block_var_1 = require("./topic-section-block-var");
const topic_section_card_var_1 = require("./topic-section-card-var");
const topic_section_divider_var_1 = require("./topic-section-divider-var");
const topic_section_featured_var_1 = require("./topic-section-featured-var");
const topic_section_gallery_var_1 = require("./topic-section-gallery-var");
const topic_section_headline_var_1 = require("./topic-section-headline-var");
const topic_section_hero_var_1 = require("./topic-section-hero-var");
const topic_section_image_var_1 = require("./topic-section-image-var");
const topic_section_quote_var_1 = require("./topic-section-quote-var");
const topic_section_showcase_var_1 = require("./topic-section-showcase-var");
const topic_section_video_var_1 = require("./topic-section-video-var");
const componentList = {
    block: topic_section_block_var_1.TopicSectionBlockVar,
    card: topic_section_card_var_1.TopicSectionCardVar,
    divider: topic_section_divider_var_1.TopicSectionDividerVar,
    featured: topic_section_featured_var_1.TopicSectionFeaturedVar,
    gallery: topic_section_gallery_var_1.TopicSectionGalleryVar,
    headline: topic_section_headline_var_1.TopicSectionHeadlineVar,
    hero: topic_section_hero_var_1.TopicSectionHeroVar,
    image: topic_section_image_var_1.TopicSectionImageVar,
    quote: topic_section_quote_var_1.TopicSectionQuoteVar,
    showcase: topic_section_showcase_var_1.TopicSectionShowcaseVar,
    video: topic_section_video_var_1.TopicSectionVideoVar,
};
exports.TopicSection = (props) => {
    const Variation = core_1.getVariation(props, componentList);
    return react_1.default.createElement(Variation, Object.assign({}, props));
};
//# sourceMappingURL=topic-section.js.map